import React, { useRef } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

export default function (props) {
  const {
    label,
    clearable,
    onBlur,
    onChange,
    InputProps,
    toolTipContent = "",
    ...rest
  } = props;
  const inputRef = useRef();
  var toolTipContents =
    toolTipContent != ""
      ? toolTipContent
      : rest.enableTooltip &&  rest.value?.length > 0
      ? rest.value
      : "";

  function handleClear() {
    inputRef.current.value = "";
    if (onBlur) return onBlur("");
    if (onChange) return onChange("");
  }

  function handleBlur(e) {
    if (onBlur) onBlur(e.target.value);
  }

  function handleChange(e) {
    if (onChange) onChange(e.target.value);
  }
  return (
    <Tooltip title={toolTipContents}>
      <TextField
        label={label}
        inputRef={inputRef}
        variant="outlined"
        autoComplete="off"
        InputProps={
          InputProps || {
            endAdornment: clearable && props.value && (
              <InputAdornment position="end" style={{ marginRight: -8 }}>
                <IconButton
                  size="small"
                  onClick={handleClear}
                  disabled={props.disabled}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ),
          }
        }
        onBlur={handleBlur}
        onChange={handleChange}
        {...rest}
      />
    </Tooltip>
  );
}
